import { useFormikContext } from "formik";
import styled from "@emotion/styled";

import { useFormData } from "../../../contexts/FormData";

import { DateTime } from "luxon";

import { useTheme } from "@emotion/react";

import { Card, CardHeader, CardContent, IconButton } from "@mui/material";

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from "../../../utils/utilities/CardComponents";

import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import RemoveCircleOutlineRoundedIcon from '@mui/icons-material/RemoveCircleOutlineRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import EventAvailableRoundedIcon from '@mui/icons-material/EventAvailableRounded';
import RequestQuoteRoundedIcon from '@mui/icons-material/RequestQuoteRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import PhoneAndroidRoundedIcon from '@mui/icons-material/PhoneAndroidRounded';

import { BasicFlex, LabelChip } from "../../../utils/Common";

import SimpleChip from "../../../utils/utilities/SimpleChip";

import { addMinutes, formatPhoneNumber } from "../../../utils/util";


const SummaryCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;


const Sidebar = () => {
  const { values } = useFormikContext();
  const { formValues, setFormValues } = useFormData() || {};

  const { appointment_type, appointment_date, start_time, clients, services } = values

  const { title, end_time, duration_in_minutes, subtotal, stylist_name, customer_name, customer_phone, block_color } = formValues

  const theme = useTheme();

  const basicBlock = [
    { header: "Appointment Type", icon: <EventAvailableRoundedIcon fontSize="small" />, info: appointment_type },
    { header: "Service", icon: <AutoFixHighRoundedIcon fontSize="small" />, info: title },
    { header: "Stylist", icon: <AccountBoxOutlinedIcon fontSize="small" />, info: services?.[0]?.stylist_name },
    { header: "Appointment Date", icon: <CalendarMonthRoundedIcon fontSize="small" />, info: appointment_date, dataType: "date" },
    { header: "Appointment Time", icon: <AccessTimeRoundedIcon fontSize="small" />, info: start_time, dataType: "time" },
    { header: "End Time", icon: <AccessTimeRoundedIcon fontSize="small" />, info: end_time, dataType: "time" },
  ];

  const stylistBlock = [
    { header: "Stylist", icon: <AccountBoxOutlinedIcon fontSize="small" />, info: stylist_name},
  ];

  const customerBlock = [
    { header: "Customer", icon: <AccountBoxOutlinedIcon fontSize="small" />, info: customer_name},
    { header: "Phone", icon: <PhoneAndroidRoundedIcon fontSize="small" />, info: formatPhoneNumber(customer_phone)},
  ];

  const stats = [
    // { header: "Number of Clients", icon: <Groups2RoundedIcon fontSize="small" />, info: clients?.length, dataType: "number" },
    { header: "Number of Services", icon: <ListAltRoundedIcon fontSize="small" />, info: services?.length, dataType: "number" },
    { header: "Total Duration", icon: <AccessTimeRoundedIcon fontSize="small" />, info: duration_in_minutes, dataType: "number"},
    { header: "Total Price", icon: <RequestQuoteRoundedIcon fontSize="small" />, info: subtotal || 0, dataType: "currency" },
  ];

  // const itemBlock = [
  //   {header: "Num of Items", info: formValues.items.length, dataType: "number"},
  //   {header: "Total Qty", info: formValues.wigs.length, dataType: "number"},
  // ];

  return (
    <SummaryCards>
      <Card variant="outlined">
        <CardHeader title="Appointment Summary" action={<SummarizeRoundedIcon color="action" />} />
        <CardContent>
          <CardBlockContainer>
            <CardBlockHeader>Appointment Information</CardBlockHeader>
            {basicBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />

            {/* <CardBlockHeader>Stylist Information</CardBlockHeader>
            {stylistBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer /> */}

            <CardBlockHeader>Customer Information</CardBlockHeader>
            {customerBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />

            <CardBlockHeader>Appointment Stats</CardBlockHeader>
            {stats.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))}
            <CardSpacer />

            {/* <CardBlockHeader>Content Summary</CardBlockHeader>
            {itemBlock.map((block) => (
              <CardBlock key={block.header} {...block} />
            ))} */}
            
          </CardBlockContainer>
          {/* <pre>{JSON.stringify({ ...values, ...formValues }, null, 2)}</pre> */}
        </CardContent>
      </Card>
    </SummaryCards>
  );
};

export default Sidebar;